import "moment/locale/ar";
import { useState } from "react";
import { DateTimeAppointmentBtn } from "../../../../Share";  
import { AppointmentDetailsDrawer, AppointmentStatusTag } from "../../../Appointments/component";

interface AppointmentPatientCardProps {
  item: any;
}

const AppointmentPatientCard: React.FC<AppointmentPatientCardProps> = ({
  item,
}) => {
  const [isAppointmentDetailsOpen, setIsAppointmentDetailsOpen] =
    useState<boolean>(false);

  return (
    <>
      <div
        className="flex cursor-pointer items-center justify-between gap-2 rounded-lg bg-InputFieldColor p-2"
        onClick={() => setIsAppointmentDetailsOpen(true)}
      >
        <div className="flex items-center gap-2">
          <DateTimeAppointmentBtn date={item?.Date} />
        </div>
        <AppointmentStatusTag statusCode={item?.Status} />
      </div>

      {isAppointmentDetailsOpen && (
        <AppointmentDetailsDrawer
          item={item}
          isOpen={isAppointmentDetailsOpen}
          onClose={() => {
            setIsAppointmentDetailsOpen(false);
          }}
        />
      )}
    </>
  );
};

export default AppointmentPatientCard;
